const MISSING_VALUE = '';

function isFinite(val) {
  return !(
    val === Number.POSITIVE_INFINITY || val === Number.NEGATIVE_INFINITY
  );
}

function hasValue(val) {
  if (val === 0 || val === false) return true;
  // if(typeof val === 'string' && val === '') return false;
  return (val && isFinite(val)) || null;
}

export function numberFormatter(value, decimals = 0) {
  try {
    let newVal = value?.toString ? value.toString() : value;
    if (newVal === 'Blocked') return newVal;
    if (newVal == null || newVal === '') return MISSING_VALUE;
    const str = parseFloat(newVal).toLocaleString('en-US', {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    });
    if (str === 'NaN') return MISSING_VALUE;
    if (str === '-0') return '0';
    return str;
  } catch (e) {
    console.error('error formatting number:', e);
    return value;
  }
}

export function percentFormatter(value, decimals = 2) {
  try {
    let newVal = value?.toString ? value.toString() : value;
    if (newVal === 'Blocked') return newVal;
    if (newVal == null || newVal === '') return MISSING_VALUE;
    const str = (parseFloat(newVal) * 100).toFixed(decimals);
    if (str === 'NaN') return MISSING_VALUE;
    if (str === '-0') return '0%';
    return `${str}%`;
  } catch (e) {
    console.error('error formating percent:', e);
    return value;
  }
}

export function currencyFormatter(value, decimals = 0) {
  let newVal = value?.toString ? value.toString() : value;
  if (newVal === 'Blocked') return newVal;
  if (newVal == null || newVal === '') return MISSING_VALUE;
  const formatVal = Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(newVal);
  return formatVal;
}

export function ssnFormatter({ value, node }) {
  const ssn = value?.toString();
  if (ssn === 'Blocked' || !ssn || node.rowPinned) return ssn;
  if (ssn.replace(/\s/g, '').length === 0) return ssn;
  return `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(5)}`;
};

export function minutesFormatter({ value }) {
  let newValue = value;
  if (typeof value === 'object' && value?.toString) newValue = value.toString();
  if (!hasValue(newValue)) return MISSING_VALUE;
  const valueFloat = parseFloat(newValue);
  const minutes = Math.floor(valueFloat);
  const seconds = Math.round((valueFloat * 60) % 60);
  // If the second is less then 10 then add a 0
  const accountForSingleSec = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${accountForSingleSec}`;
}

// comparitors
export function numericComparator(valueA, valueB, nodeA, nodeB, isDescending) {
  if (valueA == null) return isDescending ? -1 : 1;
  if (valueB == null) return isDescending ? 1 : -1;
  return parseFloat(valueA) - parseFloat(valueB);
}

export   function formatTime({ value }) {
  if (value && value.toString() !== '') {
    const v = value.toString();
    const [hours, minutes, seconds] = v.split(':');
    return `${hours}:${minutes}`;
  }
  return null;
}
